import { render } from "./AddCouleurModal.vue?vue&type=template&id=177b91ee&ts=true"
import script from "./AddCouleurModal.vue?vue&type=script&lang=ts"
export * from "./AddCouleurModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__